import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { IHeaderNotificationPayload, IHeadNotificationResponse } from '@modules/notification/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { HEADER_NOTIFICATION_QUERY_KEY, HEADER_NOTIFICATION_URL } from '@modules/notification/constants';
import { keepPreviousData } from '@tanstack/vue-query';

export default function useHeaderNotificationQuery(payload: Ref<IHeaderNotificationPayload | undefined>): IContextQueryResult<
  IHeadNotificationResponse,
  Error
> {
  const { fetchGet } = useRestClient();

  return useContextQuery<IHeadNotificationResponse, Error>({
    queryKey: [HEADER_NOTIFICATION_QUERY_KEY, payload],
    queryFn: async ({ signal }) => fetchGet(HEADER_NOTIFICATION_URL, {
      signal,
      queryParams: { namespace: payload.value?.namespace, locale: payload.value?.locale },
    }),
    placeholderData: keepPreviousData,
    enabled: computed(() => !!payload.value),
  });
}
